import React, { useState, useEffect } from 'react';
import Table from 'view/component/Table';
import apiService from 'apiService';
import { InlineLoading } from 'view/component/Loading';

const toBase64 = async (file) => {
  if (await file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }
};

const UploadFile = ({ data, idPendaftaran }) => {
  const [ isLoading, setIsLoading ] = useState(false);
  const [ isCompleted, setIsCompleted ] = useState(false);
  const [ error, setError ] = useState('');

  const handleChange = async (e, data) => {
    setIsLoading(true);
    const fileBase64 = await toBase64(e.target.files[ 0 ]);
    const param = {
      pendaftaran_id: idPendaftaran,
      penilaian_id: data.id,
      jenis_pendaftaran: 'pirt',
      jenis_perbaikan: 'penilaian',
      upload: fileBase64,
    };
    try {
      const result = await apiService.post(
        'department/perbaikan/upload',
        param
      );
      if (result) {
        setIsLoading(false);
        setIsCompleted(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <label>
        <span className='text-success pr-2'>
          {isCompleted && <span>sukses <i className='fas fa-check-circle fa-1x' /></span>}
        </span>
      </label>
      {!isCompleted && <input type='file' onChange={ (e) => handleChange(e, data) } />}
      <br />
      {isLoading ? (
        <InlineLoading isLoading={ isLoading } />
      ) : error ? (
        <span className='text-danger'>{error}</span>
      ) : (
        ''
      )}
    </>
  );
};

const Perbaikan = ({
  data,
  idPendaftaran,
}) => {
  const openFile = (url) => {
    const win = window.open(url, '_blank');
    if (!win) {
      win.focus();
    }
  };

  return (
    <>
      <h2 className='mb-2'> Hasil Penilaian</h2>
      <Table
        pagination={ false }
        headers={ [ 'No', 'Nama', 'Score', 'Keterangan', 'File Terdahulu', 'Upload File' ] }
        data={ data }
        columnMapper={ (value, i) => {
          return [
            <span
              style={ {
                whiteSpace: 'initial',
                overflow: 'hidden',
              } }>
              {value.name} (Bobot: {value.bobot})
            </span>,
            <span>{value.nilai}</span>,
            <span>{value.keterangan}</span>,
            value.trx_perbaikan ? (
              <span
                onClick={ () => openFile(value.trx_perbaikan.upload) }
                className='text-primary'
                style={ { cursor: 'pointer' } }>
                Lihat file perbaikan terdahulu
              </span>
            ) : (
              'Tidak ada file'
            ),
            value.nilai <= 0 ? (
              <>
                <UploadFile data={ value } idPendaftaran={ idPendaftaran } />
              </>
            ) : <div className="badge badge-pill badge-primary">Lulus Penilaian</div>,
          ];
        } }
      />
    </>
  );
};

export default Perbaikan;
